<template>
    <the-section class="references" legend="Our trophies" id="trophies">
        <div class="header">
            <h2 class="title">We join forces with <strong>big guns</strong></h2>
        </div>
        <div class="grid">
            <div
                v-for="reference in $store.state.references"
                class="reference"
                ref="reference"
                :key="reference.id"
            >
                <img
                    :src="getUrl(reference.logo.id)"
                    :title="reference.label"
                />
            </div>
        </div>
    </the-section>
</template>

<script>
import TheSection from "@/components/TheSection";
import getters from "@/mixins/getters.mixin";
import { clearScroll, scroll, scrollBatch } from "@/services/scroll.animation";

export default {
    mixins: [getters],
    components: { TheSection },
    computed: {
        section() {
            return this.getSection("references");
        },
    },
    mounted() {
        scroll("references-section", this.$el, this.section.colors);
        scrollBatch("references-logos", this.$refs.reference);
    },
    beforeDestroy() {
        clearScroll("references-section");
        clearScroll("references-logos");
    },
};
</script>

<style lang="sass" scoped>
@import ~styles/base
@import ~styles/typography

.references
    display: flex
    justify-content: center
    align-items: center
    color: white

    +media('<large')
        flex-direction: column

    +media('>=large')
        justify-content: space-between

.header

    +media('<large')
        margin-top: 0
        margin-bottom: calc(var(--line-base) * 2)
        text-align: center

    +media('>=large')
        flex-basis: 33.333%

.title
    +media('>=large')
        max-width: 8em

.grid
    display: grid
    grid-template-columns: repeat(4, minmax(0, 1fr))
    flex-basis: 50%
    gap: 0 4em

    +media('>=large')
        grid-template-columns: repeat(6, minmax(0, 1fr))

.reference
    text-align: center
    grid-column: span 2

    +media('>=large')
        opacity: 0

    &:last-child:nth-child(3n - 1)
        grid-column-end: -2

    &:nth-last-child(2):nth-child(3n + 1)

        +media('>=large')
            grid-column-end: 4

    img
        display: block
        max-width: 100%
</style>
